import { render, staticRenderFns } from "./WhiteListForm.vue?vue&type=template&id=3d2d5c7a"
import script from "./WhiteListForm.vue?vue&type=script&lang=js"
export * from "./WhiteListForm.vue?vue&type=script&lang=js"
import style0 from "./WhiteListForm.vue?vue&type=style&index=0&id=3d2d5c7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports